
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c8b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c8b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
"use strict";

var $72z4V = parcelRequire("72z4V");

var $l8biK = parcelRequire("l8biK");

var $le7Hi = parcelRequire("le7Hi");
var $e73bf42412feb220$var$_amplifyconfiguration2 = $e73bf42412feb220$var$_interopRequireDefault($le7Hi);
var $2af249225bdc8257$exports = {};
"use strict";
Object.defineProperty($2af249225bdc8257$exports, "__esModule", {
    value: true
});
/* eslint-disable */ // this is an auto generated file. This will be overwritten
const $2af249225bdc8257$var$createVote = /* GraphQL */ $2af249225bdc8257$exports.createVote = `
  mutation CreateVote(
    $input: CreateVoteInput!
    $condition: ModelVoteConditionInput
  ) {
    createVote(input: $input, condition: $condition) {
      id
      vote
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
const $2af249225bdc8257$var$updateVote = /* GraphQL */ $2af249225bdc8257$exports.updateVote = `
  mutation UpdateVote(
    $input: UpdateVoteInput!
    $condition: ModelVoteConditionInput
  ) {
    updateVote(input: $input, condition: $condition) {
      id
      vote
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;
const $2af249225bdc8257$var$deleteVote = /* GraphQL */ $2af249225bdc8257$exports.deleteVote = `
  mutation DeleteVote(
    $input: DeleteVoteInput!
    $condition: ModelVoteConditionInput
  ) {
    deleteVote(input: $input, condition: $condition) {
      id
      vote
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
  }
`;


function $e73bf42412feb220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$72z4V.DefaultAmplify.configure($e73bf42412feb220$var$_amplifyconfiguration2.default);
const $e73bf42412feb220$var$client = (0, $l8biK.generateClient)();
const $e73bf42412feb220$var$MAX_VOTES = 4;
document.querySelectorAll(".vote").forEach((item)=>{
    console.log("add listener");
    item.addEventListener("click", $e73bf42412feb220$var$sendVote);
});
function $e73bf42412feb220$var$getVoteCount() {
    const cookie = document.cookie.split("; ").find((row)=>row.startsWith("sbgcvotecount26="));
    return cookie ? parseInt(cookie.split("=")[1], 10) : 0;
}
function $e73bf42412feb220$var$setVoteCount(count) {
    document.cookie = "sbgcvotecount26=" + count + "; expires=Sun, 12 Feb 2026 23:59:59 GMT; Secure";
}
function $e73bf42412feb220$var$getLastVote() {
    const cookie = document.cookie.split("; ").find((row)=>row.startsWith("sbgcvote26="));
    return cookie ? cookie.split("=")[1] : null;
}
function $e73bf42412feb220$var$setLastVote(votedFor) {
    document.cookie = "sbgcvote26=" + votedFor + "; expires=Sun, 12 Feb 2026 23:59:59 GMT; Secure";
}
async function $e73bf42412feb220$var$sendVote(e) {
    var votedFor = e.target.dataset.ad;
    var currentCount = $e73bf42412feb220$var$getVoteCount();
    if (currentCount >= $e73bf42412feb220$var$MAX_VOTES) return; // Already at max votes
    document.getElementById("options").classList.remove("novote");
    document.getElementById("options").classList.add("done");
    document.getElementById("instructions").innerText = "Processing your vote...";
    try {
        gtag("event", votedFor);
        const newVote = await $e73bf42412feb220$var$client.graphql({
            query: $2af249225bdc8257$exports.createVote,
            variables: {
                input: {
                    vote: votedFor
                }
            }
        });
        console.log(newVote);
        currentCount++;
        $e73bf42412feb220$var$setVoteCount(currentCount);
        $e73bf42412feb220$var$setLastVote(votedFor);
        document.getElementById(votedFor).classList.add("yes");
        document.getElementById("instructions").innerText = "Thanks for voting!";
    } catch (err) {
        console.error(err);
        currentCount++;
        $e73bf42412feb220$var$setVoteCount(currentCount);
        $e73bf42412feb220$var$setLastVote(votedFor);
        document.getElementById(votedFor).classList.add("yes");
        document.getElementById("instructions").innerText = "Thanks for voting!";
    }
}
function $e73bf42412feb220$var$init() {
    console.log("run init");
    var currentCount = $e73bf42412feb220$var$getVoteCount();
    //OPEN FOR VOTE
    /*
  if (currentCount >= MAX_VOTES) {
    // User has used all votes
    var lastVote = getLastVote();
    document.getElementById("options").classList.add("done");
    if (lastVote) {
      document.getElementById(lastVote).classList.add("yes");
    }
    document.getElementById("instructions").innerText = "Thanks for voting!";
  } else {
    // User can still vote
    document.getElementById("options").classList.add("novote");
    document.getElementById("instructions").innerText =
      "Vote for your favorite!";
  }
  */ //END OPEN VOTE
    document.getElementById("termsLink").onclick = function() {
        document.getElementById("terms").classList.toggle("show");
    };
    //VOTE CLOSED
    document.getElementById("options").classList.add("done");
    document.getElementById("bud26").classList.add("yes");
    document.getElementById("instructions").innerText = "Voting is closed. See you next year!";
}
window.onload = function() {
    $e73bf42412feb220$var$init();
};


//# sourceMappingURL=index.67bec74c.js.map
